<template>
  <div>
    <pre-regis-stepper
      v-if="panel_state >= PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS"
      :page_step_panel_state="page_step_panel_state"
      :panel_state="panel_state"
      :PANEL_ALL_PAGE_STATE="PANEL_ALL_PAGE_STATE"
    />
    <v-row class="text-center grey lighten-2 mb-4 mx-auto" style="color: #555;">
      <v-col cols="12" md="4">
        {{ $t("pre_regis_panel.student_id") }} : {{ student_id }}
      </v-col>
      <v-col cols="12" md="4">
        {{ $t("pre_regis_panel.name_surname") }}:
        {{ inlineTranslator({ en: student_name_en, th: student_name_th }) }}
      </v-col>
      <v-col cols="12" md="4">
        {{ $t("pre_regis_panel.semester") }} : {{ semester }} / {{ year }}
      </v-col>
    </v-row>
    <!-- ------------------------------------------------ -->
    <div class="px-1 px-md-3 px-xl-6">
      <div v-if="panel_state === PANEL_ALL_PAGE_STATE.DISPLAY_FLOW_CHART">
        <pre-regis-flow-chart
          :clickNext="
            () =>
              (panel_state = PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS)
          "
        />
      </div>

      <div
        v-if="panel_state === PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS"
      >
        <pre-regis-confirm-consent
          :clickNext="() => (panel_state = PANEL_ALL_PAGE_STATE.ADD_SUBJECT)"
        />
      </div>

      <div v-if="panel_state === PANEL_ALL_PAGE_STATE.ADD_SUBJECT">
        <pre-regis-add-subject
          :clickNext="
            () => (panel_state = PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT)
          "
          :year="year"
          :semester="semester"
          :student_id="student_id"
        />
      </div>

      <div v-if="panel_state === PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT">
        <pre-regis-complete
          :year="year"
          :semester="semester"
          :student_id="student_id"
        />
      </div>
      <div v-if="panel_state === PANEL_ALL_PAGE_STATE.FALLBACK">
        ERROR: Fallback panel_state
      </div>
    </div>
  </div>
</template>

<script>
import PreRegisAddSubject from "./components/PreRegisAddSubject.vue";
import PreRegisComplete from "./components/PreRegisComplete.vue";
import PreRegisFlowChart from "./components/PreRegisFlowChart.vue";
import PreRegisStepper from "./components/PreRegisStepper.vue";
import { inlineTranslator } from "@/helper/translator";

const PANEL_ALL_PAGE_STATE = {
  DISPLAY_FLOW_CHART: 0,
  CONFIRM_CONSENT_BEFORE_REGIS: 1,
  ADD_SUBJECT: 2,
  COMPLETE_SUBJECT: 3,
  FALLBACK: 99,
};

export default {
  name: "PreRegistrationPanel",
  components: {
    PreRegisStepper,
    PreRegisFlowChart,
    PreRegisAddSubject,
    PreRegisComplete,
  },
  props: {
    all_page_states: {
      type: Object,
    },
    page_state: {
      type: String,
      default: "",
    },
    year: {
      type: String,
    },
    semester: {
      type: String,
    },
    student_id: {
      type: String,
    },
  },
  data: () => ({
    PANEL_ALL_PAGE_STATE,
    panel_state: PANEL_ALL_PAGE_STATE.FALLBACK,
  }),
  computed: {
    student_name_en() {
      if (this.$store.state.user.surrogated_student_info)
        return (
          this.$store.state.user.surrogated_student_info.fname_en +
          " " +
          this.$store.state.user.surrogated_student_info.lname_en
        );
      return null;
    },
    student_name_th() {
      if (this.$store.state.user.surrogated_student_info)
        return (
          this.$store.state.user.surrogated_student_info.fname_th +
          " " +
          this.$store.state.user.surrogated_student_info.lname_th
        );
      return null;
    },
    // ใช้ทำเส้น timeline เฉยๆ เลขจะตรงกับที่แสดงใน dot
    page_step_panel_state() {
      if (
        this.panel_state === PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS
      )
        return 1;
      if (this.panel_state === PANEL_ALL_PAGE_STATE.ADD_SUBJECT) return 2;
      if (this.panel_state === PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT) return 3;
      else return 0;
    },
  },
  methods: {
    inlineTranslator,
  },
  mounted() {
    if (this.page_state === this.all_page_states.PRE_REGIS)
      this.panel_state = PANEL_ALL_PAGE_STATE.ADD_SUBJECT;
    else if (this.page_state === this.all_page_states.SUMMARY_PRE_REGIS)
      this.panel_state = PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT;
    else this.panel_state = PANEL_ALL_PAGE_STATE.FALLBACK;
  },
};
</script>
